class FieldReferenceDto {
    Id: number;
    Name: string;
    Type: number;
    IsMultiple: boolean;
    IsRequired: boolean;
    IsPrimaryKey: boolean;
    TypeLabel: string;
    constructor(
        id: number,
        name: string,
        type: number,
        isMultiple: boolean,
        isRequired: boolean,
        isPrimaryKey: boolean,
        typeLabel: string
    ) {
        this.Id = id;
        this.Name = name;
        this.Type = type;
        this.IsMultiple = isMultiple;
        this.IsRequired = isRequired;
        this.IsPrimaryKey = isPrimaryKey;
        this.TypeLabel = typeLabel;
    }
}

export default FieldReferenceDto;